import React from "react";

import { clsx } from "clsx";

/** @deprecated */
export function withFocusRing<P extends { className?: string }>(
  WrappedComponent: React.ComponentType<P>,
) {
  return (props: P) => {
    return (
      <WrappedComponent
        {...props}
        className={clsx(
          props.className,
          "focus-visible:outline-dashed focus-visible:outline-1 focus-visible:outline-offset-1 focus-visible:outline-current",
        )}
      />
    );
  };
}
